import { render, staticRenderFns } from "./NextButton.vue?vue&type=template&id=cb11beb0&scoped=true"
import script from "./NextButton.vue?vue&type=script&lang=js"
export * from "./NextButton.vue?vue&type=script&lang=js"
import style0 from "./NextButton.vue?vue&type=style&index=0&id=cb11beb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb11beb0",
  null
  
)

export default component.exports